<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import AppIcon from '@/components/ui/AppIcon.vue'

/**
 * Поиск адреса поверх карты: белая плашка 358×50 r20, иконка лупы 24,
 * текст 13 Medium и крестик очистки 18 — как на фреймах «Старт».
 */
const query = defineModel<string>({ default: '' })

const { t } = useI18n()

const isFilled = computed(() => query.value.length > 0)
</script>

<template>
  <label class="address-search" :class="{ 'address-search--filled': isFilled }">
    <AppIcon name="search" :size="24" class="address-search__icon" />
    <input v-model="query" type="text" :placeholder="t('onboarding.addressPlaceholder')" />
    <button
      v-if="isFilled"
      type="button"
      class="address-search__clear"
      :aria-label="t('common.clear')"
      @click="query = ''"
    >
      <AppIcon name="close-circle" :size="18" />
    </button>
  </label>
</template>

<style scoped lang="scss">
.address-search {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 50px;
  padding: 0 13px;
  border-radius: var(--radius-xl);
  background: var(--surface-muted);
  cursor: text;

  /* Пустое поле в макете серое, с текстом — белое: так его видно на карте */
  &--filled {
    background: var(--surface-card);
  }

  &__icon {
    color: var(--icon-color);
  }

  input {
    width: 100%;
    padding: 0;
    border: 0;
    background: none;
    color: var(--text-color);
    caret-color: var(--accent-500);
    font-family: inherit;
    font-size: 13px;
    font-weight: var(--fw-medium);
    line-height: 20px;
    outline: none;

    &::placeholder {
      color: var(--text-color-secondary);
    }
  }

  &__clear {
    display: flex;
    padding: 0;
    border: 0;
    background: none;
    color: var(--icon-color);
    cursor: pointer;
  }
}
</style>
